import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import i18n from 'i18next';

import { changeGlobalMomentLocale } from './i18n';
import { isLanguageType } from './utils/language';
import { setPreferredLanguage } from './reducers/root';

import * as store from './reducers/store';
import * as api from './api';

interface LanguageWrapperProps {
  children: React.ReactNode;
}

const LanguageWrapper: React.FC<LanguageWrapperProps> = ({ children }) => {
  const { search } = useLocation();
  const { replace } = useHistory();
  const dispatch = useDispatch();
  const params = new URLSearchParams(search);
  const lang = params.get('language') as api.Language.LanguageWithOther;
  const preferredLanguage = useSelector(
    (store: store.All) => store.preferredLanguage,
  );

  if (lang) {
    params.delete('language');

    replace({ search: params.toString() });
  }

  useEffect(() => {
    if (lang && isLanguageType(lang)) {
      if (lang !== preferredLanguage) {
        dispatch(setPreferredLanguage(lang));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, lang]);

  useEffect(() => {
    if (preferredLanguage && preferredLanguage !== i18n.language) {
      i18n.changeLanguage(preferredLanguage);
      changeGlobalMomentLocale(preferredLanguage);
    }
  }, [preferredLanguage]);

  return children;
};

export default LanguageWrapper;
